import {Injectable} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";

@Injectable()
export class AudioFormatService {

    // Module for packaging audio files.
    /*
     FLV Head
     -------------------------
     |  Mark:    FLV         3 bytes|
     |  Version: 1.0         1 byte |
     |  Sign:    audio 0x04  1 byte |
     |           video 0x01         |
     |           both  0x05         |
     |  HeadSize 9           4 bytes|
     -------------------------
     */
    /*
     Tag Head (metadata or audio data tags)
     -------------------------------
     | Tag type: audio  0x08 1 byte |
     |           script 0x12        |
     | Tag size: UI24        3 bytes|
     | Time pos: UI24        3 bytes|
     | Time extend:  0       1 byte |
     | Stream id:    0       3 bytes|
     --------------------------------
     if audio, followed by:
     | Audio Tag Header byte: 0xB2 for compressed =178 |
     total size: 11 byte + 1 byte
     then actual audio data
     */
    /* Script tag components (in our case):
     Metadata marker:
     --------------------------------
     | Type: string 0x02      1 byte
     | Length (of string = 10)2 bytes
     | String: "onMetaData"  10 bytes
     --------------------------------
     Parameter array:
     --------------------------------
     | Type: array  0x08      1 byte
     | array length           4 bytes (length is 7 in our case)
     | parameter[0] .. parameter[length-1]  --> see below
     | endFlag                3 bytes
     structure for each parameter:
     --------------------------------
     | name length N           2 bytes
     | name - string of length N bytes as specified in name length
     | type:                   1 byte (0x00 = double float in our case, or 0x01=boolean)
     | value:                  8 bytes for double as specified in type above, or 1 byte if boolean type

     */
    // head and tag entries are big-endian
    //
    // Overall structure in our case:
    // FLV Head
    // Size of previous tag (4 bytes - 0 for first tag)
    // First Tag = Metadata Script Tag
    // Size of previous tag (4 bytes)
    // 1st Audio Tag
    // Size of previous tag (4 bytes)
    // 2nd Audio Tag . . .
    private FLVHeaderSize = 9;
    private TagHeaderSize = 11;
    private PreviousTagLengthSize = 4;

    private writeFLVHeader(offset, view) {
        offset = this.writeCharBytes(view, offset, 'FLV');

        offset = this.writeOtherBytes(view, "setUint8", offset, 1); //version 1
        offset = this.writeOtherBytes(view, "setUint8", offset, 4); // FLV contains audio
        offset = this.writeOtherBytes(view, "setUint32", offset, this.FLVHeaderSize, false /*for big-endian*/);
        return offset;
    }


    private writeCharBytes(view, offset, string) {
        var lng = string.length;
        for (var i = 0; i < lng; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
        return offset + lng;
    }

    private writeOtherBytes(view, fnName, offset, value, isLittleEndian?):number {

        var reg = /[^0-9]*([0-9]+)/;
        var numBits:any = reg.exec(fnName)[1];
        var numBytes = numBits / 8;
        if (numBytes == 1) {
            view[fnName](offset, value);
        } else {
            view[fnName](offset, value, isLittleEndian);
        }
        return offset + numBytes;
    }


    private arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    private write3ByteBigEndian(value, offset, view) {
        var outChar0 = ((value >> 16) & 0x000000ff);
        var outChar1 = ((value >> 8) & 0x000000ff);
        var outChar2 = ((value & 0x000000ff));
        offset = this.writeOtherBytes(view, "setUint8", offset, outChar0);
        offset = this.writeOtherBytes(view, "setUint8", offset, outChar1);
        offset = this.writeOtherBytes(view, "setUint8", offset, outChar2);
        return offset;
    }

    private writeMetaDataTagHeader(MetaDataScriptSize, offset, view) {
        offset = this.writeOtherBytes(view, "setUint8", offset, 18, false);  //tag type is script - 0x12 = 18
        offset = this.write3ByteBigEndian(MetaDataScriptSize, offset, view);
        // for the first tag, time pos and time extended are all 0 (this is relative time in milliseconds from start),
        // so write these 4 bytes as Uint32
        offset = this.writeOtherBytes(view, "setUint32", offset, 0, false);
        // stream id is 3 bytes but 'always 0', so just enter byte by byte
        offset = this.write3ByteBigEndian(0, offset, view);

        return offset;
    }

    private writeMetaDataScript(offset, view, params) {
        offset = this.writeOtherBytes(view, "setUint8", offset, 2);
        offset = this.writeOtherBytes(view, "setUint16", offset, 10, false);

        offset = this.writeCharBytes(view, offset, 'onMetaData');
        // now the parameter information - 8 = array data type
        offset = this.writeOtherBytes(view, "setUint8", offset, 8);

        // then the parameters themselves


        offset = this.writeOtherBytes(view, "setUint32", offset, params.length, false);

        // for loop to output params, tag length and offsets
        for (var i = 0; i < params.length; i++) {
            offset = this.writeOtherBytes(view, "setUint16", offset, params[i].name.length, false);
            // from here
            offset = this.writeCharBytes(view, offset, params[i].name);

            if (params[i].type && (params[i].type === "boolean")) {
                offset = this.writeOtherBytes(view, "setUint8", offset, 1);// 0x1 --> code for boolean value

                offset = this.writeOtherBytes(view, "setUint8", offset, params[i].value);

            } else if (params[i].type && (params[i].type === "string")) {
                offset = this.writeOtherBytes(view, "setUint8", offset, 2);// 0x2 --> code for string value
                // then length of string, followed by string.
                offset = this.writeOtherBytes(view, "setUint16", offset, params[i].value.length, false);
                offset = this.writeCharBytes(view, offset, params[i].value);
            }
            else { // default is double
                offset = this.writeOtherBytes(view, "setUint8", offset, 0);// 0x0 --> code for number(double) value
                offset = this.writeOtherBytes(view, "setFloat64", offset, params[i].value, false);

            }
        }
        // finally, 3-byte end marker for the script as specified in the Action Message Format spec: 0x00 0x00 0x09
        offset = this.writeOtherBytes(view, "setUint8", offset, 0);
        offset = this.writeOtherBytes(view, "setUint8", offset, 0);
        offset = this.writeOtherBytes(view, "setUint8", offset, 9);
        return offset;
    }

    private writeAudioTag(offset, view, FrameSizeBytes, timePos, frameIndex, audioData) {
        offset = this.writeOtherBytes(view, "setUint8", offset, 8); // 0x08 - tag type is audio
        //need to do the awkward 3-byte entry here for size.  note need to add one to the size because the audio format tag (1 byte)
        //is counted as part of the audio data
        var tagDataSize = FrameSizeBytes + 1;
        offset = this.write3ByteBigEndian(tagDataSize, offset, view);


        // time pos is another 3-char thing
        offset = this.write3ByteBigEndian(timePos, offset, view);

        // next byte is extended time pos value (upper 8 bits of time value), but we will never have a file this long
        offset = this.writeOtherBytes(view, "setUint8", offset, 0);
        // stream id is 3 bytes but 'always 0'
        offset = this.write3ByteBigEndian(0, offset, view);


        // finally the audio format information
        offset = this.writeOtherBytes(view, "setUint8", offset, 178);
        // and the audio data itself
        var start_i = frameIndex * FrameSizeBytes;
        for (var i = start_i; i < start_i + FrameSizeBytes; i++) {
            offset = this.writeOtherBytes(view, "setUint8", offset, audioData[i]);

        }
        return offset;
    }

    private writeUncompressedAudioTag(offset, view, FrameSampleSize, timePos, frameIndex, audioData) {
        offset = this.writeOtherBytes(view, "setUint8", offset, 8); // 0x08 - tag type is audio
        //need to do the awkward 3-byte entry here for size.  note need to add one to the size because the audio format tag (1 byte)
        //is counted as part of the audio data
        var tagDataSize = FrameSampleSize * 2 + 1;
        //tagDataSize = FrameSampleSize * 2;
        offset = this.write3ByteBigEndian(tagDataSize, offset, view);

        // time pos is another 3-char thing
        offset = this.write3ByteBigEndian(timePos, offset, view);

        // next byte is extended time pos value (upper 8 bits of time value), but we will never have a file this long
        offset = this.writeOtherBytes(view, "setUint8", offset, 0);
        // stream id is 3 bytes but 'always 0'
        offset = this.write3ByteBigEndian(0, offset, view);

        // finally the audio format information
        offset = this.writeOtherBytes(view, "setUint8", offset, 58);
        // and the audio data itself
        var start_i = frameIndex * FrameSampleSize;
        for (var i = start_i; i < start_i + FrameSampleSize; i++) {
            offset = this.writeOtherBytes(view, "setInt16", offset, audioData[i], true); // uncompressed audio format is LITTLE endian unlike the header data!

        }
        return offset;
    }


    public base64ToArrayBuffer(base64) {

        //base64 = base64.replace(/\s/g, '');
        var binary_string = window.atob(base64);
        var len = binary_string.length;

        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    public getCompressedFLV(audioInfo, type):any {

        var audioData = audioInfo.data;
        var FrameSampleSize = audioInfo.frameSize;
        var numFrames = audioInfo.numFrames;
        var audioSampleRate = audioInfo.sampleRate;

        var MetaDataScriptSize = 168; // 168 without encoder entry
        var MetaDataTotalSize = this.TagHeaderSize + MetaDataScriptSize;
        // infer the frame size.
        var FrameSizeBytes = audioData.length / numFrames;

        var audioTagSize = this.PreviousTagLengthSize + this.TagHeaderSize + FrameSizeBytes + 1; // +1 is for audio format byte in each tag
        var len = this.FLVHeaderSize + this.PreviousTagLengthSize + MetaDataTotalSize; // FLV header and meta data tag
        len += numFrames * (audioTagSize); // length of audio frames
        var buffer = new ArrayBuffer(len);
        var view = new DataView(buffer);

        var offset = 0;
        offset = this.writeFLVHeader(offset, view);
        offset = this.writeOtherBytes(view, "setUint32", offset, 0, false); //size of previous tag - 0 since this is first tag
        // Metadata Tag - basically an Action Message Format for an AS object graph
        var startTagOffset = offset;
        //Metadata tag header
        offset = this.writeMetaDataTagHeader(MetaDataScriptSize, offset, view);

        // Now, the actual script data
        var duration = numFrames * FrameSampleSize / audioSampleRate; // in seconds
        var params = [
            {name: "duration", value: duration},
            {name: "audiodatarate", value: 0}, //not sure why 0 but that is how it is in current plug-in
            {name: "audiosamplerate", value: audioSampleRate},
            {name: "audiosamplesize", value: 16},
            {name: "stereo", value: false, type: "boolean"},
            {name: "audiocodecid", value: 11}, // 11 = Speex
            {name: "filesize", value: len}
        ];
        // now write this metadata script to the metadata tag
        offset = this.writeMetaDataScript(offset, view, params);
        var lastTagSize = offset - startTagOffset; // calculate the last tag size.  should be 168 + 11 according to precol
        var timePos = 0;
        for (var frameIndex = 0; frameIndex < numFrames; frameIndex++) {
            offset = this.writeOtherBytes(view, "setUint32", offset, lastTagSize, false); // first time thru this is metadata tag size, after that audio tag size
            offset = this.writeAudioTag(offset, view, FrameSizeBytes, timePos, frameIndex, audioData);
            timePos += FrameSampleSize * 1000 / audioSampleRate; // time in milliseconds
            lastTagSize = this.TagHeaderSize + FrameSizeBytes + 1; // not including last tag size marker itself
        }
        if (type === "blob") { // blob for download & debugging
            // our final binary blob
            return new Blob([view], {type: 'audio/flv'});
        } else { // base64 encode for upload
            return this.arrayBufferToBase64(buffer);
        }

    }

    public getUncompressedFLV(audioData, audioSampleRate, type):any {
        audioSampleRate = 22050; // override with value supported by Flash

        var MetaDataScriptSize = 193; // 168 without encoder entry
        var MetaDataTotalSize = this.TagHeaderSize + MetaDataScriptSize; //? check this
        var FrameSampleSize = 2048; // try this first
        var numFrames = Math.floor(audioData.length / FrameSampleSize);
        var audioTagSize = this.PreviousTagLengthSize + this.TagHeaderSize + 1 + FrameSampleSize * 2; // + 1 is for audio format byte; *2 is because samples are 2-byte shorts
        var len = this.FLVHeaderSize + this.PreviousTagLengthSize + MetaDataTotalSize; // FLV header and meta data tag
        len += numFrames * (audioTagSize); // length of audio frames
        var buffer = new ArrayBuffer(len);
        var view = new DataView(buffer);
        //File header
        var offset = 0;
        offset = this.writeFLVHeader(offset, view);

        offset = this.writeOtherBytes(view, "setUint32", offset, 0, false); //size of previous tag - 0 since this is first tag
        // Metadata Tag - basically an Action Message Format for an AS object graph
        // I was hoping it was not necessary, but the file won't play without it.
        var startTagOffset = offset; //? or include tag size above?? seems not
        //Metadata tag header
        offset = this.writeMetaDataTagHeader(MetaDataScriptSize, offset, view);
        // then the parameters themselves
        // pretend 16KHz data is 22050 for the sake of debugging
        // and set some other values up to match files that do play
        //var duration = audioData.length/audioSampleRate; // in seconds
        var duration = audioData.length / audioSampleRate; // in seconds
        var audiodatarate = audioSampleRate / 64;
        var params = [{name: "duration", value: duration}, {
            name: "audiodatarate",
            value: audiodatarate
        }, {name: "audiosamplerate", value: audioSampleRate},
            {name: "audiosamplesize", value: 16}, {
                name: "stereo",
                value: false,
                type: "boolean"
            }, {name: "audiocodecid", value: 3},
            {name: "encoder", type: "string", value: "Lavf55.48.100"}, {name: "filesize", value: len}];

        // Now, the actual script data
        offset = this.writeMetaDataScript(offset, view, params);

        var lastTagSize = offset - startTagOffset; // should be 168 + 11 according to precol
        var timePos = 0;
        for (var frameIndex = 0; frameIndex < numFrames; frameIndex++) {
            offset = this.writeOtherBytes(view, "setUint32", offset, lastTagSize, false); // first time thru this is metadata tag size, after that audio tag size

            //Audio tag header - insert tag length (of prev), and all of these offsets will need to be fixed!
            offset = this.writeUncompressedAudioTag(offset, view, FrameSampleSize, timePos, frameIndex, audioData);
            timePos += FrameSampleSize * 1000 / audioSampleRate; // time in milliseconds
            lastTagSize = this.TagHeaderSize + 1 + FrameSampleSize * 2; // size here does not include the last tag size marker itself
        }
        if (type === "blob") { // blob for download & debugging
            // our final binary blob
            return new Blob([view], {type: 'audio/flv'});
        } else { // base64 encode for upload
            return this.arrayBufferToBase64(buffer);
        }

    }

    public getWAV(audioData, audioSampleRate, type):any {
        // create the wav blob - header and data
        var buffer = new ArrayBuffer(44 + audioData.length * 2);
        var view = new DataView(buffer);
        // header
        // RIFF chunk descriptor

        this.writeCharBytes(view, 0, 'RIFF');
        view.setUint32(4, 44 + audioData.length * 2 - 8, true); //total len in bytes, less 'RIFF'+'WAVE'
        this.writeCharBytes(view, 8, 'WAVE');
        // FMT sub-chunk
        this.writeCharBytes(view, 12, 'fmt ');
        view.setUint32(16, 16, true); //size of next 6 fields
        view.setUint16(20, 1, true);  //1 = PCM
        // stereo (2 channels)
        view.setUint16(22, 1, true);  // num channels
        view.setUint32(24, audioSampleRate, true); // samp per sec
        view.setUint32(28, audioSampleRate * 2, true); // bytes per sec
        view.setUint16(32, 2, true); //bytes per sample
        view.setUint16(34, 16, true);//bits per sample
        // data sub-chunk
        this.writeCharBytes(view, 36, 'data');
        view.setUint32(40, audioData.length * 2, true);
        // data
        var lng = audioData.length;
        var index = 44;
        for (var i = 0; i < lng; i++) {
            view.setInt16(index, audioData[i], true);
            index += 2;
        }
        if (type === "blob") {
            // our final binary blob
            return new Blob([view], {type: 'audio/wav'});
        } else if (type === "view") {
            //return a view for LAME?
            return view;
        } else {
            // base64 encode
            return this.arrayBufferToBase64(buffer);
        }


    }

    public getM4A(audioData, type):any {
        // create the wav blob - header and data
        var buffer = audioData;
        console.log("buffer byte length:" + buffer.byteLength);

        if (type === "blob") {
            // our final binary blob
            return new Blob([buffer], {type: 'audio/mp4'});
        } else {
            return this.arrayBufferToBase64(buffer);
        }

    }

    public getMP3(audioData, type):any {
        // create the mp3 blob - header and data
        var buffer = audioData.data;
        if (type === "blob") {
            // our final binary blob
            return new Blob([buffer], {type: 'audio/mp3'});
        } else {
            return this.arrayBufferToBase64(buffer);
        }

    }

}
